import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
    selector: 'app-add-contact-dialog',
    templateUrl: './add-contact-dialog.component.html',
    styleUrls: ['./add-contact-dialog.component.css'],
    standalone: false
})
export class AddContactDialogComponent implements OnInit {
  //myForm!: FormGroup;
  categories = ['Personal', 'Health', 'Legal', 'Finance'];
  //countries = ['USA', 'India', 'Germany', 'France'];
  // @BlockUI()
  // blockUI!: NgBlockUI; 
  submitted = false
  status: any;
  items: any;
  myForm: any;
  contactForm!: FormGroup;
  Categories: any[] = [
    { id: 'personal', title: 'Personal', count: 0, icon: 'person', isActive: true },
    // { id: 'health', title: 'Health', count: 0, icon: 'favorite', isActive: false },
    { id: 'legal', title: 'Legal & Finance', count: 0, icon: 'gavel', isActive: false },
    // { id: 'finance', title: 'Finance', count: 0, icon: 'folder', isActive: false },
    { id: 'others', title: 'Others', count: 0, icon: 'more_horiz', isActive: false },
  ];
  Affiliations: any[] = [];
  countries: any[] = [];
  countryObj: any = {
    "Argentina": "ar",
    "Australia": "au",
    "Austria": "at",
    "Belgium": "be",
    "Bosnia": "ba",
    "Brazil": "br",
    "Bulgaria": "bg",
    "Canada": "ca",
    "Chile": "cl",
    "China": "cn",
    "Croatia": "hr",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Estonia": "ee",
    "Finland": "fi",
    "France": "fr",
    // "Germany": "de",
    "Herzegovina": "ba",
    "Iceland": "is",
    "India": "in",
    "Indonesia": "id",
    "Israel": "il",
    "Italy": "it",
    "Latvia": "lv",
    "Lithuania": "lt",
    "Macedonia": "mk",
    "Malaysia": "my",
    "Mexico": "mx",
    "Moldova": "md",
    "Montenegro": "me",
    "Netherlands": "nl",
    "New Zealand": "nz",
    "Norway": "no",
    "Poland": "pl",
    "Portugal": "pt",
    "Romania": "ro",
    "Serbia": "rs",
    "Singapore": "sg",
    "Slovakia": "sk",
    "Slovenia": "si",
    "South Africa": "za",
    "South Korea": "kr",
    "Spain": "es",
    "Sweden": "se",
    "Switzerland": "ch",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Arab Emirates": "ae",
    "United Kingdom": "gb",
    "USA": "us"
  };

  constructor(private fb: FormBuilder, private auth: AuthService,
    private dialog: MatDialog, private toast: ToastrService,
    private dialogRef: MatDialogRef<AddContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  // myForm = this.fb.group({
  // })
  // ngOnInit() {
  //   this.myForm = this.fb.group({
  //     name: ['', Validators.required],
  //     address: ['', Validators.required],
  //     id: ['', Validators.required],
  //     id_no: [''],
  //     others: ['']
  //   });
  // }

  ngOnInit(): void {
    // console.log('data',this.data)

    let apiCategory = this.data?.contact?.category; // e.g. "LegalFinance"
    if (apiCategory === 'LegalFinance') {
      apiCategory = 'Legal & Finance';
    }

    this.myForm = this.fb.group({
      name: [this.data?.contact?.name, Validators.required],
      //email: [this.data?.contact?.email, Validators.required],
      email: [this.data?.contact?.email, [Validators.required, Validators.email]],
      address: [this.data?.contact?.address],
      // id: [this.data?.contact?.id || '', Validators.required],
      // id_no: [this.data?.contact?.biz_identification_no || ''],
      // category: [this.data?.contact?.category || ''],
      category: [apiCategory || ''],
      affiliation_type: [this.data?.contact?.affiliation_type || ''],
      notes: [this.data?.contact?.notes || ''],
    });

    this.getDummyRel();
    this.getCountries();
  }

  get f() {
    return this.myForm.controls;
  }
  getDummyRel() {
    this.auth.get_AddressBook().subscribe((res: any) => {
    })
  }
  onSubmit() {
    this.submitted = true;
    if (this.myForm.invalid) {
      return;
    }

    const formValue = this.myForm.value;
    console.log('formval', formValue)

    if (formValue?.category === "Legal & Finance") {
      formValue.category = "LegalFinance"
    }

    const payload = {
      name: formValue.name,
      email: formValue.email,
      address: formValue.address,
      // account_id: formValue.id,
      // biz_identification_no: formValue.id_no,
      category: formValue.category,
      affiliation_type: formValue.affiliation_type,
      notes: formValue.notes,
    };

    if (this.data?.contact) {
      //console.log('Updating contact:', this.data.contact.id, payload);
      // this.auth.update_AddressBook(this.data?.contact.id, payload).subscribe((res: any) => {
      //   if (res.error == false) {
      //     this.toast.success("Relationship updated successfully")
      //     this.auth.get_AddressBook().subscribe((res: any) => {
      //       if (res.error == false) {
      //         this.dialogRef.close(payload);
      //       }
      //     })
      //   } else {
      //     this.toast.error(res.msg)
      //   }
      // })
      this.auth.update_AddressBook(this.data?.contact.id, payload).subscribe({
        next: (res: any) => {
          this.toast.success('A contact was saved successfully', 'Success');
          this.auth.get_AddressBook().subscribe((res2: any) => {
            if (!res2.error) {
              this.dialogRef.close(payload);
            }
          });
        },
        error: (err) => {
          //console.log('Update error:', err);
          let errMsg = 'Something went wrong';
          if (Array.isArray(err.error?.errors)) {
            errMsg = err.error.errors.map((e: any) => e.msg).join(', ');
          } else if (err.error?.msg) {
            errMsg = err.error.msg;
          }
          this.toast.error(errMsg);
        }
      });
    }
    else {
      // this.auth.add_AddressBook(payload).subscribe((res: any) => {
      //   if (res.error === false) {
      //     this.toast.success(res.msg);
      //     this.auth.get_AddressBook().subscribe((res: any) => {
      //       if (res.error === false) {
      //         // handle response
      //         this.dialogRef.close(payload);
      //       }
      //     });
      //   } else {
      //     this.toast.error(res.msg);
      //   }
      // });
      this.auth.add_AddressBook(payload).subscribe({
        next: (res: any) => {
          this.toast.success(res.msg || 'Added successfully', 'Success');
          this.auth.get_AddressBook().subscribe((res2: any) => {
            if (!res2.error) {
              this.dialogRef.close(payload);
            }
          });
        },
        error: (err) => {
          console.log('err:', err);
          let errMsg = 'Something went wrong';
          if (err.error?.errors && Array.isArray(err.error.errors)) {
            errMsg = err.error.errors.map((e: any) => e.msg).join(', ');
          } else if (err.error?.msg) {
            errMsg = err.error.msg;
          }
          this.toast.error(errMsg);  // show toast
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
    this.myForm.reset();
  }

  getCountries() {
    // this.auth.getCountries().subscribe((res: any) => {
    //   const allCountries = res.data.countries;

    //   // Filter out "Choose country" and similar placeholders
    //   const filtered = allCountries.filter(
    //     ([value, label]: [string, string]) => label !== 'Choose country'
    //   );

    //   // Map to id/title object
    //   this.Affiliations = filtered.map(([id, title]: [string, string]) => ({
    //     id,
    //     title
    //   }));
    // });

    this.auth.getCountries().subscribe((resp: any) => {
      this.Affiliations = resp.data.countries;
      this.Affiliations = Object.entries(this.countryObj);
    })
  }

  add_entity(name: any, email: any, address: any, id: any, id_no: any, category: any, affiliation_type: any, notes: any) {
    this.submitted = true
    if (this.myForm.invalid) {
      return
    }
    //this.start_loading()

    let payload = { "name": name, "email": email, "address": address, "category": category, "affiliation_type": affiliation_type, "notes": notes }
    this.auth.add_entity_dummy(payload).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success(res.msg)
        this.auth.get_AddressBook().subscribe((res: any) => {
          if (res.error == false) {
            //this.stop_loading()
            //this._communicationService.emitChange(res)
            //this.close_dialog()
          }
        })
      } else {
        //this.stop_loading()
        this.toast.error(res.msg)
      }
    })

  }

  // start_loading() {
  //   this.blockUI.start()
  // }
  // stop_loading() {
  //   this.blockUI.stop()
  // }
  // edit_entity(name, address, id, id_no, others) {

  //   this.submitted = true
  //   if (this.myForm.invalid) {
  //     return
  //   }
  //   this.start_loading()
  //   let payload = { "firm_name": name, "firm_address": address, "account_id": id, "biz_identification_no": id_no, "others": others }
  //   this.auth.edit_entity_dummy(this.items.id, payload).subscribe((res: any) => {
  //     if (res.error == false) {
  //       this.toast.success(res.msg)
  //       this.auth.get_entity_dummy().subscribe((res: any) => {
  //         if (res.error == false) {
  //           this.stop_loading()
  //           this._communicationService.emitChange(res)
  //           this.close_dialog()
  //         }
  //       })
  //     } else {
  //       this.stop_loading()
  //       this.toast.error(res.msg)
  //     }
  //   })

  // }

  // close_dialog() {
  //   if (this.submitted == false && this.myForm.dirty) {
  //     this.save.confirm("Alert").then((res) => {
  //       if (res) {
  //         this.dialogRef.close()
  //       }
  //     })


  //   } else {
  //     this.dialogRef.close()
  //   }
  // }
}
